<template>
  <div class="payment-bubble">
    <BubbleHeader>{{message.message_description}}</BubbleHeader>
    <template v-if="$hasPermission('can_view_payments')">
      <MsgblContent :type="message.direction" v-if="message.showEntityLink">
        <FrontageLink :to="route" :params="{uid: this.message.data[2][1]}" >
          <MsgblLinkHeader icon="payments"
                          :title="message.appointment_title" />
        </FrontageLink>
      </MsgblContent>

      <MsgblContent :type="message.direction" v-if="message.showEntityCard">
        <FrontageLink :to="route" :params="{uid: this.message.data[2][1]}" >
          <MsgblLinkHeader icon="payments"
                          :title="message.appointment_title"/>
        </FrontageLink>
        <MsgblTextRow>
          <MsgblTextLabel>{{$t('payment.info.amount')}}:</MsgblTextLabel>
          <MsgblTextValue>{{getLinkAmount}}</MsgblTextValue>
        </MsgblTextRow>

        <MsgblTextRow>
          <MsgblTextLabel>{{$t('payment.info.link_sent_on')}}:</MsgblTextLabel>
          <MsgblTextValue>{{message.created_at_h}}</MsgblTextValue>
        </MsgblTextRow>

      </MsgblContent>
    </template>

    <MsgblNoAccess v-else
                   icon="payments"
                   :direction="message.direction">
    </MsgblNoAccess>

  </div>
</template>

<script>
import {
  BubbleHeader,
  BubbleTextRow,
  BubbleTextMsg,
  MsgblContent,
  MsgblLinkHeader,
  MsgblTextRow,
  MsgblNoAccess,
  MsgblTextLabel,
  MsgblTextValue,
  MsgblActions,
} from './helpers'
import {FrontageLink} from "@/modules/common/components"

export default {

  name: 'PaymentStatusBubble',
  components: {
    BubbleHeader,
    BubbleTextRow,
    BubbleTextMsg,
    FrontageLink,
    MsgblContent,
    MsgblLinkHeader,
    MsgblTextRow,
    MsgblActions,
    MsgblNoAccess,
    MsgblTextLabel,
    MsgblTextValue
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  computed: {
    route() {
      let payable_type = this.message.data[3][1]
      if (payable_type === 'ClientBookingPackage')
        return 'app.client-package.show'
      else if (payable_type === 'Invoice')
        return 'app.invoice.show'
      else if (payable_type === 'Meeting')
        return 'app.appointment.show'
      else if (payable_type === 'ProductOrder')
        return 'app.product-order.show'
    },
    getLinkAmount() {
        let amount = this.message.data[0][1]
        let currency = this.message.data[1][1]
        return `${this.$options.filters.amountWithCurrency(amount, currency)} ${currency}`
    }

  },
}
</script>
